export class Collapse {
  private details: HTMLDetailsElement
  private content: HTMLElement
  private button: HTMLButtonElement

  constructor(details: HTMLDetailsElement) {
    this.details = details
    this.content = details.querySelector<HTMLElement>('.content')!
    this.button =
      details.parentElement!.querySelector<HTMLButtonElement>('button.collapse-btn')!
    this.details.addEventListener('command', event => {
      const e = event as CommandEvent
      e.stopPropagation()
      if (e.command !== '--toggle') return
      this.toggle()
    })
  }

  open() {
    this.content.attributeStyleMap.set('height', CSS.px(0))
    this.details.open = true
    requestAnimationFrame(() =>
      this.content.attributeStyleMap.set('height', CSS.px(this.content.scrollHeight))
    )
    const onEnd = () => this.content.attributeStyleMap.delete('height')
    this.content.addEventListener('transitionend', onEnd, { once: true })
    this.button.classList.add('opened')
  }

  close() {
    this.content.attributeStyleMap.set('height', CSS.px(this.content.scrollHeight))
    requestAnimationFrame(() => this.content.attributeStyleMap.set('height', CSS.px(0)))
    const onEnd = () => {
      this.details.open = false
      this.content.attributeStyleMap.delete('height')
    }
    this.content.addEventListener('transitionend', onEnd, { once: true })
    this.button.classList.remove('opened')
  }

  toggle() {
    return this.details.open ? this.close() : this.open()
  }
}
